// @ts-nocheck
import { lazy } from 'react';
export const AddAddressScreenAsync = lazy(
  () => import('./AddAddressScreen.tsx'),
);
